document.addEventListener('DOMContentLoaded', function () {
  const btnShow = document.querySelector('.js-show-rules');
  const btnHide = document.querySelector('.js-hidden-rules');
  const htmlTag = document.documentElement; // <html>
  const modal = document.querySelector('.text-block__modal');

  if (btnShow && btnHide && modal) {
    btnShow.addEventListener('click', function () {
      htmlTag.classList.add('rules-show');
      modal.classList.add('show');
    });

    btnHide.addEventListener('click', function () {
      htmlTag.classList.remove('rules-show');
      modal.classList.remove('show');
    });
  }
});